import { withTranslation } from 'react-i18next';
import { Container, Flex } from '@/ui';
import { ProfileViewer, ProfileViewerSkeleton } from '@/components/common/molecules/ProfileViewer';
import { message, Typography } from 'antd';
import React from 'react';
import { useParams } from 'react-router';
import { getErrorMessage } from '@/utils/helpers';

export const AccountsList = withTranslation()(({
  t,
  accounts,
  emptyTitle = t('Nothing to display'),
  onDelete,
  role = null,
  structureView
}) => {
  const { id } = useParams();
  const [messageApi, messageContext] = message.useMessage();

  const handleDelete = async (investorId, deleteId) => {
    try {
      const res = await onDelete({
        investorId: investorId,
        ...(role === 'RECOMMENDERS' && { recommenderId: deleteId }),
        ...(role === 'AGENTS' && { agentId: deleteId })
      });

      if (res) messageApi.success(t('Referral connection is deleted'));
    } catch (e) {
      console.error(e);
      messageApi.error(t(getErrorMessage(e)));
    }
  };

  const { error, list, isLoading } = accounts;

  if (isLoading)
    return (
      <Container $marginTop={16}>
        {[1, 2, 3].map((item) => (
          <Container $marginBottom={12} key={item}>
            <ProfileViewerSkeleton />
          </Container>
        ))}
      </Container>
    );

  if (error) return <Typography.Text type={'danger'}>{t('An error occurred')}</Typography.Text>;

  if (!list || list.length < 1) {
    return (
      <Container $marginTop={16}>
        <Typography.Text>{emptyTitle}</Typography.Text>
      </Container>
    );
  }

  return (
    <Flex vertical gap={8} $marginTop={16}>
      {messageContext}
      {list.map((item) => (
        <ProfileViewer
          avatarUrl={item.avatar}
          firstName={item.firstName}
          lastName={item.lastName}
          size={'medium'}
          marginBottom={12}
          key={item.id}
          onDelete={() => handleDelete(id, item.id)}
          structureView={structureView}
        />
      ))}
    </Flex>
  );
});
